import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const formatDate = isoString => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getNameFromArray = (id, array) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i].id == id) {
      return array[i].name;
    }
  }
};

export const formatPhoneNumber = phoneNumber => {
  const phoneNumberParsed = parsePhoneNumberFromString(phoneNumber);

  if (phoneNumberParsed) {
    return phoneNumberParsed.formatInternational();
  }

  return phoneNumber;
};

export const resultInfo = (icon, title, confirmButtonText) => {
  Swal.fire({
    icon: icon,
    title: title,
    confirmButtonText: confirmButtonText,
  });
};

export const logOutIfTokenExpired = (title, confirmButtonText) => {
  Cookies.remove('fname');
  Cookies.remove('user_id');
  Cookies.remove('user_type');
  Cookies.remove('tokenClient');

  Swal.fire({
    title: title,
    icon: 'warning',
    confirmButtonText: confirmButtonText,
  }).then(result => {
    if (result.isConfirmed) {
      window.location.reload();
    }
  });
};

export const debounce = (func, delay) => {
  let timeoutId;

  return function(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const debounceAsync = (func, delay) => {
  let timeoutId;

  return async function(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    return new Promise((resolve, reject) => {
      timeoutId = setTimeout(async () => {
        try {
          const result = await func.apply(this, args);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
  };
};

const generateBreadcrumbs = (breadcrumbs = []) => {
  const breadcrumbsArray = [
    { name: 'GRC.UA', item: `https://${window.location.host}` },
    ...breadcrumbs,
  ];

  return breadcrumbsArray.map((breadcrumb, index) => {
    const listItem = {
      '@type': 'ListItem',
      'position': index + 1,
      'name': breadcrumb.name,
    };

    if (breadcrumb.item) {
      listItem.item = breadcrumb.item;
    }

    return listItem;
  });
};

export const addBreadcrumbSchema = breadcrumbs => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': generateBreadcrumbs(breadcrumbs),
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.innerHTML = JSON.stringify(structuredData, null, 2);
  document.head.appendChild(script);

  return script;
};

export const generateBreadcrumbsForSearchJobPage = slugData => {
  const { categoryName, initialRegion, initialKeyword, subCategoryName, initialCategorySlug, initialSubCategorySlug } = slugData;

  const breadcrumbs = [
    { name: 'GRC.UA', url: `https://${window.location.host}` },
    { name: 'Пошук вакансій', url: `https://${window.location.host}/searchjob` },
  ];

  if (initialKeyword) {
    breadcrumbs.push({
      name: initialKeyword,
      url: `https://${window.location.host}/searchjob/k-${initialKeyword}`,
    });
  }

  if (initialCategorySlug) {
    breadcrumbs.push({
      name: categoryName,
      url: `https://${window.location.host}/searchjob/c-${initialCategorySlug}`,
    });
  }

  if (initialSubCategorySlug) {
    breadcrumbs.push({
      name: subCategoryName,
      url: `https://${window.location.host}/searchjob/s-${initialSubCategorySlug}`,
    });
  }

  if (initialRegion) {
    breadcrumbs.push({
      name: initialRegion,
      url: `https://${window.location.host}/searchjob/r-${initialRegion}`,
    });
  }

  return breadcrumbs;
};

export const addBreadcrumbSchemaForSearchJobPage = breadcrumbs => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.innerHTML = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.name,
      'item': item.url,
    })),
  }, null, 2);
  document.head.appendChild(script);

  return script;
};
